import createAction from '../../../../util/createAction';

export const CHOOSE_TIER = 'addon/manual/tier/SELECT';
export const chooseTier = createAction(CHOOSE_TIER);
